import {Injectable} from '@angular/core';
import * as CryptoTS from 'crypto-ts';
import {encryption_key} from "../../../../fe-insights-v2/src/environments/environment";
import {environment} from "../../../../fe-insights-v2/src/environments/environment";

@Injectable({
    providedIn: 'root'
})
export class EncryptionService {
    private secure: any = environment['isSecure'] ? environment['isSecure'] : false;
    private Key: string = encryption_key.key;

    constructor() {
        let oldIsSecure = localStorage.getItem('isSecure')
        if (oldIsSecure != this.secure.toString()) {
            localStorage.clear()
            location.reload()
            localStorage.setItem('isSecure', this.secure)
        }
    }

    encryptionAES(data: any) {
        const ciphertext = CryptoTS.AES.encrypt(data, this.Key);
        return ciphertext.toString();
    }

    decryptionAES(data: any) {
        try {
            if (data) {
                const bytes = CryptoTS.AES.decrypt(data, this.Key);
                const plaintext = bytes.toString(CryptoTS.enc.Utf8);
                return plaintext;
            } else {
                return null;
            }
        } catch (error) {
            console.error('Decryption error:', error);
            localStorage.clear();
            location.reload()
        }
    }



    setDataToLocalStorage(key: string, value: any) {
        localStorage.setItem(key, this.encryptionAES(value));
    }
    getDataFromLocalStorage(key: string) {
        return this.decryptionAES(localStorage.getItem(key));
    }
    removeDataFromLocalStorage(key: string) {
        return this.decryptionAES(localStorage.removeItem(key));
    }
    setDataToSessionStorage(key: string, value: any) {
        sessionStorage.setItem(key, this.encryptionAES(value));
    }
    getDataFromSessionStorage(key: string) {
        return this.decryptionAES(sessionStorage.getItem(key));
    }
    removeDataFromSessionStorage(key: string) {
        return this.decryptionAES(sessionStorage.removeItem(key));
    }
}
